import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchProject } from '../../actions/project_actions'
import { getNameFromToken, withAuth } from '../../actions';

class ProjectApproval extends Component {
    constructor (props) {
        super(props);

        this.state = {
            isProjectApproveChecked: false,
            username: '',
            isLoading: false,
            lastApprovedOn: null,
            lastApprovedby: ''
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.getDateForDisplay = this.getDateForDisplay.bind(this);
    }

    componentDidMount() {
        const username = getNameFromToken();
        this.setState({ username });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { lastApprovedOn, lastApprovedby } = this.state;
        
        if (nextProps.info) {
            let newLastApprovedOn;
            let newLastApprovedBy;
            
            if (nextProps.info.projectInfoApprovalDate && new Date(nextProps.info.projectInfoApprovalDate) != lastApprovedOn) {
                newLastApprovedOn = new Date(nextProps.info.projectInfoApprovalDate);
                this.setState({
                    lastApprovedOn: newLastApprovedOn,
                });
            }

            if (nextProps.info.projectInfoApprovedBy && nextProps.info.projectInfoApprovedBy != lastApprovedby) {
                newLastApprovedBy = nextProps.info.projectInfoApprovedBy;
                this.setState({
                    lastApprovedby: newLastApprovedBy
                });
            }
        }
    }

    getDateForDisplay(date) {
        if (!date) return '';

        if (Object.prototype.toString.call(date) === '[object String]') {
            date = new Date(date);
        }

        let dateString = (date.getMonth() + 1)+ '/' + date.getDate() + '/' + date.getFullYear();
        return dateString;
    }

    handleSubmit() {
        if (this.state.isProjectApproveChecked) {

            const url = `/projects/${this.props.projectId}`;
            this.setState({ isLoading: true });
        
            const info = {
                ...this.props.info,
                projectInfoApprovalDate: this.getDateForDisplay(new Date()), 
                projectInfoApprovedBy: this.state.username
            };

            return withAuth (
                {method: 'put', url: url, data: info},
                () => {
                    this.setState({ 
                        isLoading: false,
                        isProjectApproveChecked: false,
                        lastApprovedOn: info.projectInfoApprovalDate,
                        lastApprovedby: info.projectInfoApprovedBy
                     });
                }
             );
        }
    }

    render () {
        const { permissions } = this.props;
        const { roleModules } = permissions.editPrivileges;
        const canEdit = roleModules && roleModules.includes('Project Review Approval') ? true : false;
     
        return (
            <div id="timestamp" className="row-wide project-documents">
                <div className="col s12">
                    <h4 className="bar-bottom">
                        <span>
                            <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 640 512" className="fa-Icon" style={{verticalAlign: "middle"}} xmlns="http://www.w3.org/2000/svg"><path d="M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"/></svg>
                        </span> Project Info Review Approval 
                        {this.state.lastApprovedOn ? 
                            <p className = 'approve-timestamp'> - Last Approved by {this.state.lastApprovedby} on {this.getDateForDisplay(this.state.lastApprovedOn)}</p>
                            : null}
                    </h4>

                    <div>
                        <p>Please check this box at least once per month to confirm you have reviewed all project information and it is accurate and up-to-date:</p>
                        <input id="projectApproval"
                                type="checkbox"
                                className="margin-right-075"
                                disabled={!canEdit}
                                onChange={() => this.setState({isProjectApproveChecked: !this.state.isProjectApproveChecked})}
                                checked={this.state.isProjectApproveChecked}/>
                            <label htmlFor="projectApproval">Approval Date: {this.state.isProjectApproveChecked ? this.getDateForDisplay(new Date()) : null}
                                <span className="margin-left-175">Approver: {this.state.isProjectApproveChecked ? this.state.username : null}</span></label>
                    </div>
                </div>
            
                <div className="section-buttons">

                { this.state.isLoading ? <div className="loader"/> :null }

                    <button className="btn-save" 
                            disabled={!this.state.isProjectApproveChecked || !canEdit}
                            onClick={() => this.handleSubmit()}
                    >
                        Approve
                    </button>
                </div>
            </div>
        );
    }
}

ProjectApproval.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    fetchProject: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.projectId,
        info: state.projectsStore.info
    };
}

export default connect(mapStateToProps, {
    fetchProject
})(ProjectApproval);